export default function findInMap<TKey, TData>(
  map: Map<TKey, TData>,
  key: TKey
): TData {
  const v = map.get(key);
  if (v === undefined) throw new Error("No item found");
  return v;
}
